module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_vi-b2fa269e45d6fd3951973ba089a12f6d.jpg";